export { default } from './Layout';


// WEBPACK FOOTER //
// ./resources/assets/js/components/Layout/index.js